export class DeleteSolutionError extends Error{
}